import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import ColorPickerComponent from "../components/ColorPickerComponent";
import ColorCodedIconPickerComponent from "../components/ColorCodedIconPickerComponent";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = () => createStyles({});
const validationSchema = Yup.object().shape({
  legendCode: Yup.string().required("Legend code required"),
  inputColor: Yup.string().required("Input colour required"),
  legendDefinition: Yup.string().required("Legend definition required"),
});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  defaultValue?: any;
  handleOnSubmit: any;
  legendData: any;
}

class ItemLegendDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    type: "",
    indexSelected: -1,
  };

  handleInputColorSelected = (
    inputColor: any,
    index: any,
    setFieldValue: any
  ) => {
    this.setState(
      {
        indexSelected: index,
      },
      () => {
        setFieldValue("inputColor", inputColor);
      }
    );
  };
  render() {
    const {
      title,
      open,
      handleClose,
      handleOnSubmit,
      defaultValue,
      legendData,
    } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                legendData && legendData.legendCode
                  ? legendData
                  : {
                      legendCode: "",
                      inputColor: "",
                      iconName: "",
                      legendDefinition: "",
                    }
              }
              enableReinitialize={true}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                await handleOnSubmit(values);
                resetForm();
                this.setState({
                  indexSelected: -1,
                });
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                isValid,
                resetForm,
                setFieldValue,
              }) => (
                <Form>
                  <div>
                    <TextField
                      style={{ marginBottom: 20 }}
                      id={"legendCode"}
                      value={values.legendCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name={"legendCode"}
                      variant={"outlined"}
                      disabled={defaultValue ? true : false}
                      label={"Legend Code"}
                      fullWidth
                    />
                    <TextField
                      style={{ marginBottom: 20 }}
                      id={"legendDefinition"}
                      value={values.legendDefinition}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name={"legendDefinition"}
                      variant={"outlined"}
                      disabled={defaultValue ? true : false}
                      label={"Legend Definition"}
                      fullWidth
                    />
                    {
                      <ColorCodedIconPickerComponent
                        title={"Icons"}
                        handleInputColorSelected={(
                          iconName: any,
                          index: any
                        ) => {
                          setFieldValue("iconName", iconName);
                        }}
                        selectedColor={
                          values.inputColor ? values.inputColor : ""
                        }
                        selectedIcon={values.iconName ? values.iconName : ""}
                      />
                    }
                    {
                      <ColorPickerComponent
                        title={"Color"}
                        handleInputColorSelected={(
                          inputColor: any,
                          index: any
                        ) => setFieldValue("inputColor", inputColor)}
                        selectedColor={values.inputColor}
                      />
                    }
                    <DialogActions>
                      <Button
                        onClick={() => {
                          this.setState({
                            indexSelected: -1,
                          });
                          resetForm();
                          handleClose();
                        }}
                      >
                        {"CANCEL"}
                      </Button>
                      <Button type="submit" disabled={!isValid}>
                        {"SAVE"}
                      </Button>
                    </DialogActions>
                  </div>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ItemLegendDialog);
